import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";
import "./theme/spinner-overrides.css";
import { AppThemeProvider } from "./theme";

import NoPage from "./pages/NoPage";
import Chat from "./pages/chat/Chat";
import Share from "./pages/share/Share";
import Settings from "./pages/settings/Settings";
import UsageDashboard from "./pages/UsageDashboard/UsageDashboard";
import Help from "./pages/help/Help";
import { PromptTemplateProvider } from "./context/PromptTemplateContext";
import { PromptTemplateManager } from "./components/PromptTemplateManager";
import { ShellProvider } from "./shell/context/ShellContext";
import { NotificationProvider } from "./shell/context/NotificationContext";
import { ShellLayout } from "./shell/ShellLayout";
import { AgentsStore } from "./shell/components/AgentsStore/AgentsStore";
import { AgentHost } from "./shell/components/AgentHost/AgentHost";
import { AccessRequestsPage } from "./shell/components/AccessRequestsPage/AccessRequestsPage";
import { ErrorNotificationProvider } from "./context/ErrorNotificationContext";

initializeIcons();

export default function App() {
    return (
        <AppThemeProvider>
            <ErrorNotificationProvider>
            <PromptTemplateProvider>
                <BrowserRouter>
                    <ShellProvider>
                        <NotificationProvider>
                        <ShellLayout>
                            <Routes>
                                <Route path="/" element={<Chat />} />
                                <Route path="/share/:conversationId" element={<Share />} />
                                <Route path="/templates" element={<PromptTemplateManager />} />
                                <Route path="/settings" element={<Settings />} />
                                <Route path="/usage-dashboard" element={<UsageDashboard />} />
                                <Route path="/agents" element={<AgentsStore />} />
                                <Route path="/agent/:agentRoute" element={<AgentHost />} />
                                <Route path="/access-requests" element={<AccessRequestsPage />} />
                                <Route path="/help" element={<Help />} />
                                <Route path="*" element={<NoPage />} />
                            </Routes>
                        </ShellLayout>
                        </NotificationProvider>
                    </ShellProvider>
                </BrowserRouter>
            </PromptTemplateProvider>
            </ErrorNotificationProvider>
        </AppThemeProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
